
import { Input, DatePicker, Select, Option } from "element-ui"
// import getCartNumMixin from "../mixins/getCartNum"
import { updateInfo, getUserInfo } from "@/api/authentication"
import { base64Decode } from "@/utils/utils"

export default {
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  // mixins: [getCartNumMixin],
  // provide() {
  //   return {
  //     cascaderAsync: () => this.cascaderData
  //   }
  // },
  data() {
    return {
      // cascaderData: [],
      options: [
        { label: "Male", value: 1 },
        { label: "Female", value: 2 }
      ],
      custId: "",
      form: {
        name: "",
        email: "",
        birth: "",
        gender: ""
      },
      changed: false
    }
  },

  computed: {},
  watch: {},

  mounted() {
    const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""
    if (accountInfo && accountInfo.custId) {
      this.custId = accountInfo.custId
    }
    this.getUserInfo()
  },
  methods: {
    handleChanged() {
      this.changed = true
    },
    async getUserInfo() {
      try {
        const res = await getUserInfo({
          custId: this.custId,
          loginChannel: 3
        })
        if (res.code == "0000" && res.data) {
          this.form.name = res.data.name
          this.form.email = res.data.email
          this.form.birth = res.data.birth
          this.form.gender = res.data.gender
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleUpdate() {
      if (!this.changed) return
      try {
        const res = await updateInfo({
          custId: this.custId,
          ...this.form,
          loginChannel: 3
        })
        if (res.code == "0000") {
          this.$message.success("update success")
          this.$store.dispatch("getLoginInfo")
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
